// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__29hXf","buttons":"SendReceipts_buttons__6wUUQ","email":"SendReceipts_email__Oc8m5","bookApptTitle":"SendReceipts_bookApptTitle__2NlSI"};